import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/services/storage/storage.service';
import { Router, NavigationStart } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CommonService } from 'src/app/services/common/common.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-side-nav',
	templateUrl: './side-nav.component.html',
	styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit {
	show_side_nav: boolean = true;
	selected_role: any = '';
	user_details: any;
	nav_data: any;
	selected_route: any = '';
	profile_image: any = '';

	super_admin_nav_group_data: any = [
		{
			name: 'Master Data',
			icon: 'assets/side-navigation/master-data.png',
			activeIcon: 'assets/side-navigation/master-data-active.png',
			show_menu: false,
			sub: [
				{
					name: 'Institution Registration Types',
					route: '/admin/institution-registration-types',
					icon: 'assets/side-navigation/institution-registration-type.png',
					activeIcon: 'assets/side-navigation/institution-registration-type-active.png',
				},
				{
					name: 'Financial Institutions',
					route: '/admin/financial-institutions',
					icon: 'assets/side-navigation/financial-institution.png',
					activeIcon: 'assets/side-navigation/financial-institution-active.png',
				},
				{
					name: 'Users',
					route: '/admin/users',
					icon: 'assets/side-navigation/users.png',
					activeIcon: 'assets/side-navigation/users-active.png',
				},
			],
		},
		{
			name: 'Other Configuration',
			icon: 'assets/side-navigation/configuration.png',
			activeIcon: 'assets/side-navigation/configuration-active.png',
			show_menu: true,
			sub: [
				{
					name: 'Business Area',
					route: '/admin/business-area',
					icon: 'assets/side-navigation/business-plan.png',
					activeIcon: 'assets/side-navigation/business-plan-active.png',
				},
				{
					name: 'Model History',
					route: '/admin/model-history',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
			]
		},
		// {
		// 	name: 'Trigger Configuration',
		// 	icon: 'assets/side-navigation/configuration.png',
		// 	activeIcon: 'assets/side-navigation/configuration-active.png',
		// 	show_menu: true,
		// 	sub: [
		// 		{
		// 			name: 'Repositories',
		// 			route: '/admin/repositories',
		// 			icon: 'assets/side-navigation/repositories.png',
		// 			activeIcon: 'assets/side-navigation/repositories-active.png',
		// 		},
		// 		{
		// 			name: 'Trigger Names',
		// 			route: '/admin/triggers',
		// 			icon: 'assets/side-navigation/triggers.png',
		// 			activeIcon: 'assets/side-navigation/triggers-active.png',
		// 		},
		// 		// {
		// 		// 	name: 'Trigger Activities',
		// 		// 	route: '/admin/trigger-activities',
		// 		// 	icon: 'assets/side-navigation/trigger-activities.png',
		// 		// 	activeIcon: 'assets/side-navigation/trigger-activities-active.png',
		// 		// },
		// 		{
		// 			name: 'Trigger Activity Templates',
		// 			route: '/admin/trigger-activity-templates',
		// 			icon: 'assets/side-navigation/trigger-activities.png',
		// 			activeIcon: 'assets/side-navigation/trigger-activities-active.png',
		// 		},
		// 		{
		// 			name: 'Trigger Events',
		// 			route: '/admin/trigger-events',
		// 			icon: 'assets/side-navigation/trigger-events.png',
		// 			activeIcon: 'assets/side-navigation/trigger-events-active.png',
		// 		},
		// 		{
		// 			name: 'Trigger Frequency',
		// 			route: '/admin/trigger-frequency',
		// 			icon: 'assets/side-navigation/activity-names.png',
		// 			activeIcon: 'assets/side-navigation/activity-names-active.png',
		// 		},
		// 	],
		// },
		// {
		// 	name: 'Configuration',
		// 	icon: 'assets/side-navigation/configuration.png',
		// 	activeIcon: 'assets/side-navigation/configuration-active.png',
		// 	show_menu: true,
		// 	sub: [
		// 		{
		// 			name: 'Segmentation Groups',
		// 			route: '/admin/segmentation-groups',
		// 			icon: 'assets/side-navigation/segmentation-group.png',
		// 			activeIcon: 'assets/side-navigation/segmentation-group-active.png',
		// 		},
		// 		// {
		// 		// 	name: 'Triggers',
		// 		// 	route: '/admin/triggers',
		// 		// 	icon: 'assets/side-navigation/triggers.png',
		// 		// 	activeIcon: 'assets/side-navigation/triggers-active.png',
		// 		// },
		// 		// {
		// 		// 	name: 'Repositories',
		// 		// 	route: '/admin/repositories',
		// 		// 	icon: 'assets/side-navigation/repositories.png',
		// 		// 	activeIcon: 'assets/side-navigation/repositories-active.png',
		// 		// },
		// 		// {
		// 		// 	name: 'Trigger Activities',
		// 		// 	route: '/admin/trigger-activities',
		// 		// 	icon: 'assets/side-navigation/trigger-activities.png',
		// 		// 	activeIcon: 'assets/side-navigation/trigger-activities-active.png',
		// 		// },
		// 		// {
		// 		// 	name: 'Trigger Activity Templates',
		// 		// 	route: '/admin/trigger-activity-templates',
		// 		// 	icon: 'assets/side-navigation/trigger-activities.png',
		// 		// 	activeIcon: 'assets/side-navigation/trigger-activities-active.png',
		// 		// },
		// 		// {
		// 		// 	name: 'Trigger Events',
		// 		// 	route: '/admin/trigger-events',
		// 		// 	icon: 'assets/side-navigation/trigger-events.png',
		// 		// 	activeIcon: 'assets/side-navigation/trigger-events-active.png',
		// 		// },
		// 	],
		// },
		{
			name: 'Reference Data',
			icon: 'assets/side-navigation/reference-data.png',
			activeIcon: 'assets/side-navigation/reference-data-active.png',
			show_menu: false,
			sub: [
				{
					name: 'Activity Criticality',
					route: '/admin/client-priorities',
					icon: 'assets/side-navigation/client-priority.png',
					activeIcon: 'assets/side-navigation/client-priority-active.png',
				},
				// {
				// 	name: 'Activity Names',
				// 	route: '/admin/activity-names',
				// 	icon: 'assets/side-navigation/activity-names.png',
				// 	activeIcon: 'assets/side-navigation/activity-names-active.png',
				// },
				{
					name: 'Activity Status',
					route: '/admin/activity-status',
					icon: 'assets/side-navigation/activity-status.png',
					activeIcon: 'assets/side-navigation/activity-status-active.png',
				},
				// {
				// 	name: 'Advisor Certificates',
				// 	route: '/admin/advisor-certificates',
				// 	icon: 'assets/side-navigation/certificated.png',
				// 	activeIcon: 'assets/side-navigation/certificated-active.png',
				// },
				// {
				// 	name: 'Advisor Designations',
				// 	route: '/admin/advisor-designations',
				// 	icon: 'assets/side-navigation/designation.png',
				// 	activeIcon: 'assets/side-navigation/designation-active.png',
				// },
				// {
				// 	name: 'Advisor Employment Types',
				// 	route: '/admin/advisor-employement-types',
				// 	icon: 'assets/side-navigation/employment-type.png',
				// 	activeIcon: 'assets/side-navigation/employment-type-active.png',
				// },
				// {
				// 	name: 'Advisor Licenses',
				// 	route: '/admin/advisor-licenses',
				// 	icon: 'assets/side-navigation/licenses.png',
				// 	activeIcon: 'assets/side-navigation/licenses-active.png',
				// },
				{
					name: 'Advisor Status',
					route: '/admin/advisor-status',
					icon: 'assets/side-navigation/advisor-status.png',
					activeIcon: 'assets/side-navigation/advisor-status-active.png',
				},
				// {
				// 	name: 'Advisor Types',
				// 	route: '/admin/advisor-types',
				// 	icon: 'assets/side-navigation/advisor-type.png',
				// 	activeIcon: 'assets/side-navigation/advisor-type-active.png',
				// },
				// {
				// 	name: 'Client Priorities',
				// 	route: '/admin/client-priorities',
				// 	icon: 'assets/side-navigation/client-priority.png',
				// 	activeIcon: 'assets/side-navigation/client-priority-active.png',
				// },
				// {
				// 	name: 'Automation Configuration',
				// 	route: '/admin/automation-configuration',
				// 	icon: 'assets/side-navigation/repositories.png',
				// 	activeIcon: 'assets/side-navigation/repositories-active.png',
				// },
				{
					name: 'Client Status',
					route: '/admin/client-status',
					icon: 'assets/side-navigation/client-status.png',
					activeIcon: 'assets/side-navigation/client-status-active.png',
				},
				{
					name: 'Communication Channels',
					route: '/admin/communication-channels',
					icon: 'assets/side-navigation/communication-channel.png',
					activeIcon: 'assets/side-navigation/communication-channel-active.png',
				},
				{
					name: 'Compliance',
					route: '/admin/attributes',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
				{
					name: 'Gender',
					// route: '/admin/genders',
					route: '/admin/gender',
					icon: 'assets/side-navigation/gender.png',
					activeIcon: 'assets/side-navigation/gender-active.png',
				},
				// {
				// 	name: 'Initiative Priorities',
				// 	route: '/admin/initiative-priorities',
				// 	icon: 'assets/side-navigation/initiative-priority.png',
				// 	activeIcon: 'assets/side-navigation/initiative-priority-active.png',
				// },
				// {
				// 	name: 'Institution Registration Types',
				// 	route: '/admin/institution-registration-types',
				// 	icon: 'assets/side-navigation/institution-registration-type.png',
				// 	activeIcon: 'assets/side-navigation/institution-registration-type-active.png',
				// },
				// {
				// 	name: 'Professional Associations',
				// 	route: '/admin/professional-associations',
				// 	icon: 'assets/side-navigation/professional-associates.png',
				// 	activeIcon: 'assets/side-navigation/professional-associates-active.png',
				// },
				// {
				// 	name: 'Relationship Types',
				// 	route: '/admin/relationship-types',
				// 	icon: 'assets/side-navigation/relationship-type.png',
				// 	activeIcon: 'assets/side-navigation/relationship-type-active.png',
				// },
				// {
				// 	name: 'Services Offered',
				// 	route: '/admin/services-offered',
				// 	icon: 'assets/side-navigation/services-offered.png',
				// 	activeIcon: 'assets/side-navigation/services-offered-active.png',
				// },
				{
					name: 'States',
					route: '/admin/states',
					icon: 'assets/side-navigation/states.png',
					activeIcon: 'assets/side-navigation/states-active.png',
				},
			],
		},
	];

	admin_nav_group_data_old: any = [
		{
			name: 'Master Data',
			icon: 'assets/side-navigation/master-data.png',
			activeIcon: 'assets/side-navigation/master-data-active.png',
			show_menu: true,
			sub: [
				{
					name: 'Advisor Data',
					route: '/admin/advisor-data',
					icon: 'assets/side-navigation/advisor-data.png',
					activeIcon: 'assets/side-navigation/advisor-data-active.png',
				},
				{
					name: 'Client Data',
					route: '/admin/client-data',
					icon: 'assets/side-navigation/client-data.png',
					activeIcon: 'assets/side-navigation/client-data-active.png',
				},
				{
				  name: 'Opportunities',
				  route: '/admin/opportunities',
				  icon: 'assets/side-navigation/opportunities.png',
				  activeIcon: 'assets/side-navigation/opportunities-active.png',
				},
				{
					name: 'Product Groups',
					route: '/admin/product-groups',
					icon: 'assets/side-navigation/product-group.png',
					activeIcon: 'assets/side-navigation/product-group-active.png',
				},
				{
					name: 'Products',
					route: '/admin/products',
					icon: 'assets/side-navigation/product-configuration.png',
					activeIcon: 'assets/side-navigation/product-configuration-active.png',
				},
				{
					name: 'Users',
					route: '/admin/users',
					icon: 'assets/side-navigation/users.png',
					activeIcon: 'assets/side-navigation/users-active.png',
				},
			],
		},
		{
			name: 'Trigger Configuration',
			icon: 'assets/side-navigation/configuration.png',
			activeIcon: 'assets/side-navigation/configuration-active.png',
			show_menu: true,
			sub: [
				{
					name: 'Repositories',
					route: '/admin/repositories',
					icon: 'assets/side-navigation/repositories.png',
					activeIcon: 'assets/side-navigation/repositories-active.png',
				},
				{
					name: 'Trigger Names',
					route: '/admin/triggers',
					icon: 'assets/side-navigation/triggers.png',
					activeIcon: 'assets/side-navigation/triggers-active.png',
				},
				// {
				// 	name: 'Trigger Activities',
				// 	route: '/admin/trigger-activities',
				// 	icon: 'assets/side-navigation/trigger-activities.png',
				// 	activeIcon: 'assets/side-navigation/trigger-activities-active.png',
				// },
				{
					name: 'Trigger Activity Templates',
					route: '/admin/trigger-activity-templates',
					icon: 'assets/side-navigation/trigger-activities.png',
					activeIcon: 'assets/side-navigation/trigger-activities-active.png',
				},
				{
                            name: 'Trigger Categories',
                            route: '/admin/trigger-categories',
                            icon: 'assets/side-navigation/product-group.png',
                            activeIcon: 'assets/side-navigation/product-group-active.png',
                        },
				{
					name: 'Trigger Events',
					route: '/admin/trigger-events',
					icon: 'assets/side-navigation/trigger-events.png',
					activeIcon: 'assets/side-navigation/trigger-events-active.png',
				},
				{
					name: 'Trigger Frequency',
					route: '/admin/trigger-frequency',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
			],
		},
		{
			name: 'Configuration',
			icon: 'assets/side-navigation/configuration.png',
			activeIcon: 'assets/side-navigation/configuration-active.png',
			show_menu: true,
			sub: [
				// {
				//   name: 'Activity Template',
				//   route: '/admin/activity-templates',
				//   icon: 'assets/side-navigation/activity-templates.png',
				//   activeIcon: 'assets/side-navigation/activity-templates-active.png',
				// },
				{
					name: 'Initiative Categories',
					route: '/admin/initiative-categories',
					icon: 'assets/side-navigation/initiative-category.png',
					activeIcon: 'assets/side-navigation/initiative-category-active.png',
				},
				{
					name: 'Business Plans',
					route: '/admin/business-plans',
					icon: 'assets/side-navigation/business-plan.png',
					activeIcon: 'assets/side-navigation/business-plan-active.png',
				},
				// {
				// 	name: 'Leads Stages',
				// 	route: '/admin/leads-stages',
				// 	icon: 'assets/side-navigation/activity-status.png',
				// 	activeIcon: 'assets/side-navigation/activity-status-active.png',
				// },
				{
					name: 'Regions',
					route: '/admin/regions',
					icon: 'assets/side-navigation/region.png',
					activeIcon: 'assets/side-navigation/region-active.png',
				},
				// {
				// 	name: 'Repositories',
				// 	route: '/admin/repositories',
				// 	icon: 'assets/side-navigation/repositories.png',
				// 	activeIcon: 'assets/side-navigation/repositories-active.png',
				// },
				// {
				//   name: 'Retention Stages',
				//   route: '/admin/retention-stages',
				//   icon: 'assets/side-navigation/activity-templates.png',
				//   activeIcon: 'assets/side-navigation/activity-templates-active.png',
				// },
				// {
				// 	name: 'Sales Stages',
				// 	route: '/admin/sales-stages',
				// 	icon: 'assets/side-navigation/activity-names.png',
				// 	activeIcon: 'assets/side-navigation/activity-names-active.png',
				// },
				{
					name: 'Stages',
					route: '/admin/stages',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
				// {
				// 	name: 'Triggers',
				// 	route: '/admin/triggers',
				// 	icon: 'assets/side-navigation/triggers.png',
				// 	activeIcon: 'assets/side-navigation/triggers-active.png',
				// },
				// {
				// 	name: 'Trigger Activities',
				// 	route: '/admin/trigger-activities',
				// 	icon: 'assets/side-navigation/trigger-activities.png',
				// 	activeIcon: 'assets/side-navigation/trigger-activities-active.png',
				// },
				// {
				// 	name: 'Trigger Activity Templates',
				// 	route: '/admin/trigger-activity-templates',
				// 	icon: 'assets/side-navigation/trigger-activities.png',
				// 	activeIcon: 'assets/side-navigation/trigger-activities-active.png',
				// },
				// {
				// 	name: 'Trigger Events',
				// 	route: '/admin/trigger-events',
				// 	icon: 'assets/side-navigation/trigger-events.png',
				// 	activeIcon: 'assets/side-navigation/trigger-events-active.png',
				// },
			],
		},
		{
			name: 'Reference Data',
			icon: 'assets/side-navigation/reference-data.png',
			activeIcon: 'assets/side-navigation/reference-data-active.png',
			show_menu: true,
			sub: [
				{
					name: 'Activity Names',
					route: '/admin/activity-names',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
				{
					name: 'Activity Status',
					route: '/admin/activity-status',
					icon: 'assets/side-navigation/activity-status.png',
					activeIcon: 'assets/side-navigation/activity-status-active.png',
				},
				{
					name: 'Advisor Certificates',
					route: '/admin/advisor-certificates',
					icon: 'assets/side-navigation/certificated.png',
					activeIcon: 'assets/side-navigation/certificated-active.png',
				},
				{
					name: 'Advisor Designations',
					route: '/admin/advisor-designations',
					icon: 'assets/side-navigation/designation.png',
					activeIcon: 'assets/side-navigation/designation-active.png',
				},
				{
					name: 'Advisor Employment Types',
					route: '/admin/advisor-employement-types',
					icon: 'assets/side-navigation/employment-type.png',
					activeIcon: 'assets/side-navigation/employment-type-active.png',
				},
				{
					name: 'Advisor Licenses',
					route: '/admin/advisor-licenses',
					icon: 'assets/side-navigation/licenses.png',
					activeIcon: 'assets/side-navigation/licenses-active.png',
				},
				{
					name: 'Advisor Status',
					route: '/admin/advisor-status',
					icon: 'assets/side-navigation/advisor-status.png',
					activeIcon: 'assets/side-navigation/advisor-status-active.png',
				},
				{
					name: 'Advisor Types',
					route: '/admin/advisor-types',
					icon: 'assets/side-navigation/advisor-type.png',
					activeIcon: 'assets/side-navigation/advisor-type-active.png',
				},
				{
					name: 'Attributes',
					route: '/admin/attributes',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
				{
					name: 'Client Priorities',
					route: '/admin/client-priorities',
					icon: 'assets/side-navigation/client-priority.png',
					activeIcon: 'assets/side-navigation/client-priority-active.png',
				},
				{
					name: 'Client Status',
					route: '/admin/client-status',
					icon: 'assets/side-navigation/client-status.png',
					activeIcon: 'assets/side-navigation/client-status-active.png',
				},
				{
					name: 'Communication Channels',
					route: '/admin/communication-channels',
					icon: 'assets/side-navigation/communication-channel.png',
					activeIcon: 'assets/side-navigation/communication-channel-active.png',
				},
				{
					name: 'Genders',
					// route: '/admin/genders',
					route: '/admin/gender',
					icon: 'assets/side-navigation/gender.png',
					activeIcon: 'assets/side-navigation/gender-active.png',
				},
				{
					name: 'Initiative Priorities',
					route: '/admin/initiative-priorities',
					icon: 'assets/side-navigation/initiative-priority.png',
					activeIcon: 'assets/side-navigation/initiative-priority-active.png',
				},
				// {
				// 	name: 'Institution Registration Types',
				// 	route: '/admin/institution-registration-types',
				// 	icon: 'assets/side-navigation/institution-registration-type.png',
				// 	activeIcon: 'assets/side-navigation/institution-registration-type-active.png',
				// },
				{
					name: 'Professional Associations',
					route: '/admin/professional-associations',
					icon: 'assets/side-navigation/professional-associates.png',
					activeIcon: 'assets/side-navigation/professional-associates-active.png',
				},
				{
					name: 'Relationship Types',
					route: '/admin/relationship-types',
					icon: 'assets/side-navigation/relationship-type.png',
					activeIcon: 'assets/side-navigation/relationship-type-active.png',
				},
				{
					name: 'Segmentation Groups',
					route: '/admin/segmentation-groups',
					icon: 'assets/side-navigation/segmentation-group.png',
					activeIcon: 'assets/side-navigation/segmentation-group-active.png',
				},
				{
					name: 'Services Offered',
					route: '/admin/services-offered',
					icon: 'assets/side-navigation/services-offered.png',
					activeIcon: 'assets/side-navigation/services-offered-active.png',
				},
				{
					name: 'States',
					route: '/admin/states',
					icon: 'assets/side-navigation/states.png',
					activeIcon: 'assets/side-navigation/states-active.png',
				},
				// {
				// 	name: 'Triggers',
				// 	route: '/admin/triggers',
				// 	icon: 'assets/side-navigation/triggers.png',
				// 	activeIcon: 'assets/side-navigation/triggers-active.png',
				// },
				// {
				//   name: 'Trigger Activities',
				//   route: '/admin/trigger-activities',
				//   icon: 'assets/side-navigation/trigger-activities.png',
				//   activeIcon: 'assets/side-navigation/trigger-activities-active.png',
				// },
				// {
				// 	name: 'Trigger Activity Templates',
				// 	route: '/admin/trigger-activity-templates',
				// 	icon: 'assets/side-navigation/trigger-activities.png',
				// 	activeIcon: 'assets/side-navigation/trigger-activities-active.png',
				// },
				{
					name: 'Trainings',
					route: '/admin/trainings',
					icon: 'assets/side-navigation/trainings.png',
					activeIcon: 'assets/side-navigation/trainings-active.png',
				},
				// {
				// 	name: 'Trigger Events',
				// 	route: '/admin/trigger-events',
				// 	icon: 'assets/side-navigation/trigger-events.png',
				// 	activeIcon: 'assets/side-navigation/trigger-events-active.png',
				// },
			],
		},
	];

	admin_nav_group_data: any = [
		{
			name: 'Master Data',
			icon: 'assets/side-navigation/master-data.png',
			activeIcon: 'assets/side-navigation/master-data-active.png',
			show_menu: false,
			sub: [
				{
					// name: 'Business Dashboard',
					// name: 'Centralized Interconnected System',
					name: 'CIS',
					// route: '/admin/business-dashboard',
					route: '/admin/centralised-interconnected-system',
					icon: 'assets/side-navigation/trainings.png',
					activeIcon: 'assets/side-navigation/trainings-active.png',
				},
				{
				//   name: 'Opportunities',
				  name: 'Prospect Data',
				  route: '/admin/opportunities',
				  icon: 'assets/side-navigation/opportunities.png',
				  activeIcon: 'assets/side-navigation/opportunities-active.png',
				},
				{
					name: 'Prospect Advisor Data',
					route: '/admin/prospect-advisor-data',
					icon: 'assets/side-navigation/advisor-data.png',
					activeIcon: 'assets/side-navigation/advisor-data-active.png',
				},
			],
		},
		{
			name: 'User Configuration',
			icon: 'assets/side-navigation/master-data.png',
			activeIcon: 'assets/side-navigation/master-data-active.png',
			show_menu: false,
			sub: [
				{
					name: 'Financial Institutions',
					route: '/admin/financial-institutions',
					icon: 'assets/side-navigation/financial-institution.png',
					activeIcon: 'assets/side-navigation/financial-institution-active.png',
				},
				{
					name: 'Users',
					route: '/admin/users',
					icon: 'assets/side-navigation/users.png',
					activeIcon: 'assets/side-navigation/users-active.png',
				},
        {
					name: 'Regions',
					route: '/admin/regions',
					icon: 'assets/side-navigation/region.png',
					activeIcon: 'assets/side-navigation/region-active.png',
				},
			],
		},
    	{
			name: 'Client Configuration',
			icon: 'assets/side-navigation/master-data.png',
			activeIcon: 'assets/side-navigation/master-data-active.png',
			show_menu: false,
			sub: [
        		{
					name: 'Client Data',
					route: '/admin/client-data',
					icon: 'assets/side-navigation/client-data.png',
					activeIcon: 'assets/side-navigation/client-data-active.png',
				},
				
        		{
					name: 'Client Status',
					route: '/admin/client-status',
					icon: 'assets/side-navigation/client-status.png',
					activeIcon: 'assets/side-navigation/client-status-active.png',
				},
        		{
					name: 'Relationship Types',
					route: '/admin/relationship-types',
					icon: 'assets/side-navigation/relationship-type.png',
					activeIcon: 'assets/side-navigation/relationship-type-active.png',
				},
				{
					// name: 'Data Type Values',
					name: 'Source Data Type',
					route: '/admin/data-type-values',
					icon: 'assets/side-navigation/certificated.png',
					activeIcon: 'assets/side-navigation/certificated-active.png',
				},
				{
					name: 'Attrition Reasons',
					route: '/admin/attrition-reasons',
					icon: 'assets/side-navigation/product-group.png',
					activeIcon: 'assets/side-navigation/product-group-active.png',
				},
			],
		},
    	{
			name: 'Advisor Configuration',
			icon: 'assets/side-navigation/master-data.png',
			activeIcon: 'assets/side-navigation/master-data-active.png',
			show_menu: false,
			sub: [
        		{
					name: 'Advisor Data',
					route: '/admin/advisor-data',
					icon: 'assets/side-navigation/advisor-data.png',
					activeIcon: 'assets/side-navigation/advisor-data-active.png',
				},
       		 	{
					name: 'Advisor Certificates',
					route: '/admin/advisor-certificates',
					icon: 'assets/side-navigation/certificated.png',
					activeIcon: 'assets/side-navigation/certificated-active.png',
				},
				{
					name: 'Advisor Designations',
					route: '/admin/advisor-designations',
					icon: 'assets/side-navigation/designation.png',
					activeIcon: 'assets/side-navigation/designation-active.png',
				},
				{
					name: 'Advisor Employment Types',
					route: '/admin/advisor-employement-types',
					icon: 'assets/side-navigation/employment-type.png',
					activeIcon: 'assets/side-navigation/employment-type-active.png',
				},
				{
					name: 'Advisor Licenses',
					route: '/admin/advisor-licenses',
					icon: 'assets/side-navigation/licenses.png',
					activeIcon: 'assets/side-navigation/licenses-active.png',
				},
				{
					name: 'Advisor Status',
					route: '/admin/advisor-status',
					icon: 'assets/side-navigation/advisor-status.png',
					activeIcon: 'assets/side-navigation/advisor-status-active.png',
				},
				{
					name: 'Advisor Types',
					route: '/admin/advisor-types',
					icon: 'assets/side-navigation/advisor-type.png',
					activeIcon: 'assets/side-navigation/advisor-type-active.png',
				},
        {
					name: 'Professional Associations',
					route: '/admin/professional-associations',
					icon: 'assets/side-navigation/professional-associates.png',
					activeIcon: 'assets/side-navigation/professional-associates-active.png',
				},
				{
					name: 'Trainings',
					route: '/admin/trainings',
					icon: 'assets/side-navigation/trainings.png',
					activeIcon: 'assets/side-navigation/trainings-active.png',
				}
			],
		},
    	{
			name: 'Product Configuration',
			icon: 'assets/side-navigation/master-data.png',
			activeIcon: 'assets/side-navigation/master-data-active.png',
			show_menu: false,
			sub: [
        		{
					name: 'Product Groups',
					route: '/admin/product-groups',
					icon: 'assets/side-navigation/product-group.png',
					activeIcon: 'assets/side-navigation/product-group-active.png',
				},
				{
					name: 'Product Types',
					route: '/admin/product-types',
					icon: 'assets/side-navigation/trainings.png',
					activeIcon: 'assets/side-navigation/trainings-active.png',
				},
				{
					name: 'Products',
					route: '/admin/products',
					icon: 'assets/side-navigation/product-configuration.png',
					activeIcon: 'assets/side-navigation/product-configuration-active.png',
				},
        {
					name: 'Services Offered',
					route: '/admin/services-offered',
					icon: 'assets/side-navigation/services-offered.png',
					activeIcon: 'assets/side-navigation/services-offered-active.png',
				}
			],
		},
		{
			name: 'Trigger Configuration',
			icon: 'assets/side-navigation/configuration.png',
			activeIcon: 'assets/side-navigation/configuration-active.png',
			show_menu: false,
			sub: [
				{
					name: 'Automation Configuration',
					route: '/admin/automation-configuration',
					icon: 'assets/side-navigation/repositories.png',
					activeIcon: 'assets/side-navigation/repositories-active.png',
				},
        {
					name: 'Recruiting Triggers',
					route: '/admin/recruiting-triggers',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
				{
					name: 'Repositories',
					route: '/admin/repositories',
					icon: 'assets/side-navigation/repositories.png',
					activeIcon: 'assets/side-navigation/repositories-active.png',
				},
				{
					name: 'Trigger Names',
					route: '/admin/triggers',
					icon: 'assets/side-navigation/triggers.png',
					activeIcon: 'assets/side-navigation/triggers-active.png',
				},
				// {
				// 	name: 'Trigger Activities',
				// 	route: '/admin/trigger-activities',
				// 	icon: 'assets/side-navigation/trigger-activities.png',
				// 	activeIcon: 'assets/side-navigation/trigger-activities-active.png',
				// },
				// {
				// 	name: 'Trigger Activity Templates',
				// 	route: '/admin/trigger-activity-templates',
				// 	icon: 'assets/side-navigation/trigger-activities.png',
				// 	activeIcon: 'assets/side-navigation/trigger-activities-active.png',
				// },
				{
					name: 'Trigger Activity Templates',
					route: '/admin/trigger-activity-templates',
					icon: 'assets/side-navigation/trigger-activities.png',
					activeIcon: 'assets/side-navigation/trigger-activities-active.png',
				},
				{
                            name: 'Trigger Categories',
                            route: '/admin/trigger-categories',
                            icon: 'assets/side-navigation/product-group.png',
                            activeIcon: 'assets/side-navigation/product-group-active.png',
                        },
				{
					name: 'Trigger Events',
					route: '/admin/trigger-events',
					icon: 'assets/side-navigation/trigger-events.png',
					activeIcon: 'assets/side-navigation/trigger-events-active.png',
				},
				{
					name: 'Trigger Frequency',
					route: '/admin/trigger-frequency',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
			],
		},
		{
			name: 'Other Configuration',
			icon: 'assets/side-navigation/configuration.png',
			activeIcon: 'assets/side-navigation/configuration-active.png',
			show_menu: false,
			sub: [
				{
                    name: 'Agentic AI Governance Controls',
                    route: '/admin/agentic-ai-governance-controls',
                    icon: 'assets/side-navigation/business-plan.png',
                    activeIcon: 'assets/side-navigation/business-plan-active.png',
                },
        		{
					name: 'Initiative Priorities',
					route: '/admin/initiative-priorities',
					icon: 'assets/side-navigation/initiative-priority.png',
					activeIcon: 'assets/side-navigation/initiative-priority-active.png',
				},
				{
					name: 'Initiative Categories',
					route: '/admin/initiative-categories',
					icon: 'assets/side-navigation/initiative-category.png',
					activeIcon: 'assets/side-navigation/initiative-category-active.png',
				},
				{
					name: 'Business Plans',
					route: '/admin/business-plans',
					icon: 'assets/side-navigation/business-plan.png',
					activeIcon: 'assets/side-navigation/business-plan-active.png',
				},
        		{
					name: 'Segmentation Groups',
					route: '/admin/segmentation-groups',
					icon: 'assets/side-navigation/segmentation-group.png',
					activeIcon: 'assets/side-navigation/segmentation-group-active.png',
				},
				{
					name: 'Stages',
					route: '/admin/stages',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				}
			],
		},
		{
			name: 'Reference Data',
			icon: 'assets/side-navigation/reference-data.png',
			activeIcon: 'assets/side-navigation/reference-data-active.png',
			show_menu: false,
			sub: [
        		{
					name: 'Activity Criticality',
					route: '/admin/client-priorities',
					icon: 'assets/side-navigation/client-priority.png',
					activeIcon: 'assets/side-navigation/client-priority-active.png',
				},
				{
					name: 'Activity Status',
					route: '/admin/activity-status',
					icon: 'assets/side-navigation/activity-status.png',
					activeIcon: 'assets/side-navigation/activity-status-active.png',
				},
				{
					name: 'Advisor Capacity',
					route: '/admin/advisor-capacity',
					icon: 'assets/side-navigation/client-priority.png',
					activeIcon: 'assets/side-navigation/client-priority-active.png',
				},
				{
					name: 'Compliance',
					route: '/admin/attributes',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
				{
					name: 'Communication Channels',
					route: '/admin/communication-channels',
					icon: 'assets/side-navigation/communication-channel.png',
					activeIcon: 'assets/side-navigation/communication-channel-active.png',
				},
				{
					name: 'Gender',
					// route: '/admin/genders',
					route: '/admin/gender',
					icon: 'assets/side-navigation/gender.png',
					activeIcon: 'assets/side-navigation/gender-active.png',
				},
				// {
				// 	name: 'Document Status',
				// 	route: '/admin/proposal-status',
				// 	icon: 'assets/side-navigation/client-status.png',
				// 	activeIcon: 'assets/side-navigation/client-status-active.png',
				// },
				{
					name: 'Response',
					route: '/admin/response',
					icon: 'assets/side-navigation/client-priority.png',
					activeIcon: 'assets/side-navigation/client-priority-active.png',
				},
				{
					name: 'States',
					route: '/admin/states',
					icon: 'assets/side-navigation/states.png',
					activeIcon: 'assets/side-navigation/states-active.png',
				}
			],
		},
		{
			name: 'AI Reference Data',
			icon: 'assets/side-navigation/reference-data.png',
			activeIcon: 'assets/side-navigation/reference-data-active.png',
			show_menu: false,
			sub: [
        		{
					name: 'S&P 500',
					route: '/admin/sp-500',
					icon: 'assets/side-navigation/client-priority.png',
					activeIcon: 'assets/side-navigation/client-priority-active.png',
				},
				{
					name: 'Gross Domestic Product',
					route: '/admin/gdp',
					icon: 'assets/side-navigation/activity-status.png',
					activeIcon: 'assets/side-navigation/activity-status-active.png',
				},
				{
					name: 'Unemployment Rate',
					route: '/admin/unemployment-rate',
					icon: 'assets/side-navigation/activity-names.png',
					activeIcon: 'assets/side-navigation/activity-names-active.png',
				},
				{
					name: 'Metropolitan Statistical Area',
					route: '/admin/msa',
					icon: 'assets/side-navigation/states.png',
					activeIcon: 'assets/side-navigation/states-active.png',
				},
				{
					name: 'Earnings by Age',
					route: '/admin/earnings-by-age',
					icon: 'assets/side-navigation/business-plan.png',
					activeIcon: 'assets/side-navigation/business-plan-active.png',
				},
        		{
					name: 'Earnings by Occupation',
					route: '/admin/earnings-by-occupation',
					icon: 'assets/side-navigation/segmentation-group.png',
					activeIcon: 'assets/side-navigation/segmentation-group-active.png',
				},
			]
		},
	];

	constructor(
		private storageService: StorageService,
		private router: Router,
		private authService: AuthService,
		private commonService: CommonService,
	) {
		router.events.subscribe((event: any) => {
			if (event instanceof NavigationStart) {
				this.selected_route = event.url;
			}
		});
	}

	ngOnInit(): void {
		this.user_details = this.storageService.get('user_details');
		this.selected_role = this.user_details.role.role;
		this.profile_image = environment.apiEndpoint + '/' + this.user_details.profile_pic;
		this.getNavigationData();
		this.selected_route = this.router.url;
		this.setActiveRoute(this.router.url);
	}

	toggleNav() {
		this.show_side_nav = !this.show_side_nav;
	}

	setActiveRoute(currentRoute) {
		this.nav_data.forEach(section => {
			section.show_menu = false;
			section.sub.forEach(subItem => {
				if (subItem.route == currentRoute) {
					section.show_menu = true;
				}
			});
		});
	  }

	getNavigationData() {
		if (this.selected_role == 1) {
			this.nav_data = this.super_admin_nav_group_data;
		} else if (this.selected_role == 2) {
			this.nav_data = this.admin_nav_group_data;
		}
	}

	navigate(url) {
		this.router.navigate([url]);
	}

	logout() {
		this.authService.logout();
	}

	uploadProfilePicture(event) {
		let file: any = event.target.files[0];
		const formData = new FormData();
		formData.append('profile_pic', file);
		this.commonService.postData('/profile_picture/update/', formData).subscribe(
			(res: any) => {
				this.user_details.profile_pic = res['profile_pic'];
				this.profile_image = environment.apiEndpoint + '/' + res['profile_pic'] + '?c=' + Math.random() * 100;
				this.storageService.set('user_details', this.user_details);
				this.commonService.showToast( 'success', 'Profile Picture Updated Successfully.');
				file = '';
			},
			(err) => {
				this.commonService.showToast('error', err.error.error);
				file = '';
			},
		);
	}

	navigateToProfile() {
		// if (this.user_details.role.id == 1) {
		// 	this.router.navigate(['/admin/profile']);
		// } else if (this.user_details.role.id == 2) {
		// 	this.router.navigate(['/admin/profile']);
		// } else if (this.user_details.role.id == 3) {
		// 	// this.router.navigate(['/executive/my-portfolio']);
      // this.router.navigate(['/executive/dashboard']);
		// } else if (this.user_details.role.id == 4) {
		// 	this.router.navigate(['/advisor-manager']);
		// } else if (this.user_details.role.id == 5) {
		// 	this.router.navigate(['/advisor']);
		// } else if (this.user_details.role.id == 6) {
		// 	this.router.navigate(['/afa']);
		// } else if (this.user_details.role.id == 7) {
		// 	this.router.navigate(['/assistant']);
		// } else if (this.user_details.role.id == 8) {
		// 	this.router.navigate(['/relationship-manager']);
		// }
		if (this.user_details.role.role == 1) {
			this.router.navigate(['/admin/profile/manage-profile']);
		} else if (this.user_details.role.role == 2) {
			this.router.navigate(['/admin/profile/manage-profile']);
		} else if (this.user_details.role.role == 3) {
			this.router.navigate(['/executive/profile/manage-profile']);
		} else if (this.user_details.role.role == 4) {
			this.router.navigate(['/advisor-manager/profile/manage-profile']);
		} else if (this.user_details.role.role == 5) {
			this.router.navigate(['/advisor/profile/manage-profile']);
		} else if (this.user_details.role.role == 6) {
			this.router.navigate(['/afa/profile/manage-profile']);
		} else if (this.user_details.role.role == 7) {
			this.router.navigate(['/assistant/profile/manage-profile']);
		} else if (this.user_details.role.role == 8) {
			this.router.navigate(['/relationship-manager/profile/manage-profile']);
		} else if (this.user_details.role.role == 10) {
			this.router.navigate(['/leadership/profile/manage-profile']);
		} else if (this.user_details.role.role == 11) {
			// this.router.navigate(['/marketing-team']);
			this.router.navigate(['/opportunity']);
		} else if (this.user_details.role.role == 13) {
      this.router.navigate(['/lending-officer']);
    } else if (this.user_details.role.role == 14) {
      this.router.navigate(['/insurance-agent']);
    }

		this.toggleRoleSelection();
	}

	navigateToDashboard() {
		if (this.user_details.role.role == 1) {
			this.router.navigate(['/admin/dashboard']);
		} else if (this.user_details.role.role == 2) {
			this.router.navigate(['/admin/dashboard']);
		} else if (this.user_details.role.role == 3) {
			// this.router.navigate(['/executive/my-portfolio']);
      this.router.navigate(['/executive/dashboard']);
		} else if (this.user_details.role.role == 4) {
			this.router.navigate(['/advisor-manager']);
		} else if (this.user_details.role.role == 5) {
			this.router.navigate(['/advisor']);
		} else if (this.user_details.role.role == 6) {
			this.router.navigate(['/afa']);
		} else if (this.user_details.role.role == 7) {
			this.router.navigate(['/assistant']);
		} else if (this.user_details.role.role == 8) {
			this.router.navigate(['/relationship-manager']);
		} else if (this.user_details.role.role == 10) {
			// this.router.navigate(['/leadership/my-portfolio']);
      this.router.navigate(['/leadership/dashboard']);
		} else if (this.user_details.role.role == 11) {
			// this.router.navigate(['/marketing-team']);
			this.router.navigate(['/opportunity']);
		} else if (this.user_details.role.role == 13) {
      this.router.navigate(['/lending-officer']);
    } else if (this.user_details.role.role == 14) {
      this.router.navigate(['/insurance-agent']);
    }
	}

	show_role_details: boolean = false;
	toggleRoleSelection() {
		this.show_role_details = !this.show_role_details;
	}

	roleSelected(role) {
		this.user_details.role = role;
		this.storageService.set('user_details', this.user_details);
		this.user_details = this.storageService.get('user_details');
		if (this.user_details.role.role == 1) {
			this.nav_data = this.super_admin_nav_group_data;
		} else if (this.user_details.role.role == 2) {
			this.nav_data = this.admin_nav_group_data;
		}
		this.toggleRoleSelection();
		this.navigateToDashboard();
	}
}
